import { twMerge } from 'tailwind-merge';

import { SkeletonFilter } from '../common';
import { TableRowsBlock } from './TableRowsBlock';

type LeagueTableSkeletonProps = {
  className?: string;
};

export default function LeagueTableSkeleton(props: LeagueTableSkeletonProps) {
  const { className } = props;

  return (
    <div className={twMerge('flex flex-col gap-[12px] animate-pulse', className)}>
      <SkeletonFilter count={3} />
      <TableRowsBlock />
    </div>
  );
}
